module.exports = "/assets/6440343bb47088cc68c9ffd03f68a627.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AP.png
// module id = 2332
// module chunks = 0